import { StyledIconCloud } from './IconCloud.styled';

const IconCloud = () => {
  return <StyledIconCloud />;
};

export default IconCloud;
